import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { useField } from "react-final-form";
import { ScaleBarInput } from "@vk-hr-tek/ui/input";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ScaleBarInput_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ScaleBarInput_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const ScaleBarInput_ScaleBarInput = (t0)=>{
    const $ = c(21);
    let disabled;
    let name;
    let renderTooltip;
    let rest;
    let showEmptyIfPristine;
    let showLabel;
    let target;
    if ($[0] !== t0) {
        ({ renderTooltip, target, showLabel, disabled, showEmptyIfPristine, name } = t0), rest = _object_without_properties(t0, [
            "renderTooltip",
            "target",
            "showLabel",
            "disabled",
            "showEmptyIfPristine",
            "name"
        ]);
        $[0] = t0;
        $[1] = disabled;
        $[2] = name;
        $[3] = renderTooltip;
        $[4] = rest;
        $[5] = showEmptyIfPristine;
        $[6] = showLabel;
        $[7] = target;
    } else {
        disabled = $[1];
        name = $[2];
        renderTooltip = $[3];
        rest = $[4];
        showEmptyIfPristine = $[5];
        showLabel = $[6];
        target = $[7];
    }
    const { input, meta } = useField(name, rest);
    let t1;
    if ($[8] !== input) {
        t1 = (onChange)=>(newValue)=>{
                onChange(newValue);
                input.onBlur();
            };
        $[8] = input;
        $[9] = t1;
    } else t1 = $[9];
    const handleChange = t1;
    const t2 = meta.touched || !showEmptyIfPristine ? input.value : 0;
    let t3;
    if ($[10] !== handleChange || $[11] !== input.onChange) {
        t3 = handleChange(input.onChange);
        $[10] = handleChange;
        $[11] = input.onChange;
        $[12] = t3;
    } else t3 = $[12];
    let t4;
    if ($[13] !== disabled || $[14] !== input || $[15] !== renderTooltip || $[16] !== showLabel || $[17] !== t2 || $[18] !== t3 || $[19] !== target) {
        t4 = /*#__PURE__*/ jsx(ScaleBarInput, _object_spread_props(_object_spread({}, input), {
            target: target,
            showLabel: showLabel,
            renderTooltip: renderTooltip,
            disabled: disabled,
            value: t2,
            onChange: t3
        }));
        $[13] = disabled;
        $[14] = input;
        $[15] = renderTooltip;
        $[16] = showLabel;
        $[17] = t2;
        $[18] = t3;
        $[19] = target;
        $[20] = t4;
    } else t4 = $[20];
    return t4;
};
export { ScaleBarInput_ScaleBarInput as ScaleBarInput };
